// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Settings -> Branding. Scoped under .sb-*; shares .st-card / .st-input /
   .st-btn-sm with settings-redesign.css. Everything inside .sb-preview
   paints from the draft's --rf-* tokens set inline on that box. */

.sb-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(300px, 380px);
  gap: 16px;
  align-items: start;
}
.sb-controls {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-width: 0;
}
.sb-side {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sb-preview-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: #bdb6a7;
}

/* ---------------- presets ---------------- */
.sb-presets {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 8px;
}
.sb-preset {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 8px 9px;
  border: 1px solid #e2dcd0;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  text-align: left;
  font: 500 12.5px "Instrument Sans", Helvetica, Arial, sans-serif;
  color: #4a453c;
}
.sb-preset:hover:not(:disabled) {
  border-color: #c4bdad;
}
.sb-preset.is-on {
  border-color: var(--rf-brand);
  box-shadow: 0 0 0 1px var(--rf-brand);
  color: #191714;
  font-weight: 600;
}
.sb-preset:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.sb-preset-swatch {
  display: flex;
  height: 30px;
  border-radius: 6px;
  overflow: hidden;
}
.sb-preset-swatch i {
  flex: 1 1;
}
.sb-preset-swatch i:first-child {
  flex: 1.4 1;
}
.sb-preset-name {
  padding: 0 2px;
}
.sb-preset-check {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 18px;
  height: 18px;
  padding: 2px;
  border-radius: 50%;
  background: #fff;
  color: var(--rf-brand);
}

/* ---------------- custom seeds ---------------- */
.sb-seeds {
  display: flex;
  flex-direction: column;
  border: 1px solid #f0ece3;
  border-radius: 11px;
  overflow: hidden;
}
.sb-seed {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
}
.sb-seed + .sb-seed {
  border-top: 1px solid #f0ece3;
}
.sb-seed-chip {
  position: relative;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  flex-shrink: 0;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  overflow: hidden;
}
.sb-seed-chip input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  border: none;
  padding: 0;
}
.sb-seed-chip input:disabled {
  cursor: not-allowed;
}
.sb-seed-main {
  flex-grow: 1;
  min-width: 0;
}
.sb-seed-label {
  font-size: 13px;
  font-weight: 600;
  color: #191714;
}
.sb-seed-help {
  font-size: 11.5px;
  color: #8b8477;
}
.st-input.sb-seed-hex {
  flex-grow: 0;
  width: 96px;
  height: 30px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  text-transform: lowercase;
}
.sb-warn {
  margin: 11px 0 0;
  padding: 9px 12px 9px 28px;
  border-radius: 9px;
  background: #f9f1de;
  border: 1px solid #ecdcb4;
  font-size: 12px;
  line-height: 1.5;
  color: #6b5629;
}

/* ---------------- logo ---------------- */
.sb-logo-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}
.sb-logo-tile {
  height: 86px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border: 1px solid #e2dcd0;
}
.sb-logo-tile.is-cream {
  background: #fff;
}
.sb-logo-tile.is-paper {
  background: #fff;
  background-image: linear-gradient(45deg, #f6f4ef 25%, transparent 25%),
    linear-gradient(-45deg, #f6f4ef 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #f6f4ef 75%),
    linear-gradient(-45deg, transparent 75%, #f6f4ef 75%);
  background-size: 14px 14px;
  background-position: 0 0, 0 7px, 7px -7px, -7px 0;
}
.sb-logo-tile .sb-logo-img,
.sb-logo-tile .sb-print-logo {
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
}
.sb-logo-tile.is-cream .sb-logo-img {
  height: var(--rf-logo-h, 36px);
}
.sb-logo-tile.is-paper .sb-logo-img {
  height: var(--rf-logo-print-h, 40px);
}
.sb-monogram {
  height: 34px;
  min-width: 34px;
  padding: 0 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #e7e3da;
  color: #191714;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.04em;
}
.sb-logo-actions {
  display: flex;
  gap: 8px;
  margin-top: 11px;
  flex-wrap: wrap;
}
.sb-error {
  margin: 8px 0 0;
  font-size: 12px;
  color: #a8483e;
}
.sb-sliders {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-top: 14px;
}
.sb-range {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.sb-range-label {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #6f6a60;
}
.sb-range-label b {
  font-weight: 600;
  color: #191714;
}
.sb-range input {
  width: 100%;
  accent-color: var(--rf-brand);
}

/* ---------------- save bar ---------------- */
.sb-savebar {
  display: flex;
  flex-direction: column;
  gap: 9px;
  padding: 11px 13px;
  border-radius: 12px;
  border: 1px solid #e2dcd0;
  background: #fff;
}
.sb-savebar.is-dirty {
  border-color: #ecdcb4;
  background: #fdf8ec;
}
.sb-savebar-note {
  font-size: 12px;
  line-height: 1.45;
  color: #6f6a60;
}
.sb-savebar.is-dirty .sb-savebar-note {
  color: #6b5629;
  font-weight: 600;
}
.sb-savebar-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.sb-savebar .rf-btn-primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ---------------- preview ---------------- */
.sb-preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.sb-pv-app {
  border: 1px solid #e2dcd0;
  border-radius: 12px;
  overflow: hidden;
  background: #f4f1ea;
  font-family: "Instrument Sans", Helvetica, Arial, sans-serif;
}
.sb-pv-top {
  position: relative;
  z-index: 1;
  height: 44px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px;
  background: var(--rf-header);
}
.sb-pv-burger {
  display: inline-flex;
  flex-direction: column;
  gap: 3px;
}
.sb-pv-burger i {
  width: 14px;
  height: 2px;
  border-radius: 1px;
  background: #fff;
}
.sb-pv-logo {
  position: relative;
  z-index: 1;
  align-self: flex-start;
  height: calc(100% + 8px);
  margin-bottom: -8px;
  display: inline-flex;
  align-items: center;
  padding: 0 14px;
  background: #fff;
  box-shadow: 0 4px 10px rgba(25, 23, 20, 0.2);
}
.sb-pv-logo .sb-logo-img {
  height: calc(var(--rf-logo-h, 36px) * 0.62);
  max-width: 110px;
  object-fit: contain;
}
.sb-pv-logo .sb-monogram {
  height: 24px;
  min-width: 24px;
  font-size: 11px;
}
.sb-pv-name {
  font: 400 17px/1 "Instrument Serif", Georgia, serif;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}
.sb-pv-search {
  width: 60px;
  height: 20px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.4);
  flex-shrink: 0;
}
.sb-pv-row {
  display: flex;
  min-height: 190px;
}
.sb-pv-side {
  width: 116px;
  flex-shrink: 0;
  padding: 10px 7px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background: #fbf9f5;
  border-right: 1px solid #e2dcd0;
}
.sb-pv-nav {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 7px;
  border-radius: 6px;
  font-size: 10.5px;
  color: #6f6a60;
  white-space: nowrap;
}
.sb-pv-nav i {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #d8cfb8;
  flex-shrink: 0;
}
.sb-pv-nav b {
  margin-left: auto;
  font-size: 9.5px;
  font-weight: 600;
  color: var(--rf-brand);
}
.sb-pv-nav.is-active {
  background: var(--rf-brand-tint);
  color: #191714;
  font-weight: 600;
}
.sb-pv-nav.is-active i {
  background: var(--rf-brand);
}
.sb-pv-main {
  flex-grow: 1;
  min-width: 0;
  padding: 10px 12px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
}
.sb-pv-title {
  font: 400 17px/1.1 "Instrument Serif", Georgia, serif;
  color: #191714;
}
.sb-pv-chips {
  display: flex;
  align-items: center;
  gap: 5px;
}
.sb-pv-chip {
  padding: 2px 7px;
  border-radius: 999px;
  font-size: 9.5px;
  font-weight: 600;
  background: var(--rf-brand-tint);
  color: var(--rf-brand-deep);
  border: 1px solid var(--rf-brand-edge);
}
.sb-pv-chip.is-accent {
  background: var(--rf-accent-tint);
  color: var(--rf-accent);
  border-color: transparent;
}
.sb-pv-link {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  color: var(--rf-brand);
}
.sb-pv-bars {
  height: 54px;
  display: flex;
  align-items: flex-end;
  gap: 7px;
  padding: 6px 8px 0;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e7e3da;
}
.sb-pv-bars span {
  flex: 1 1;
  height: 100%;
  display: flex;
  align-items: flex-end;
  gap: 2px;
}
.sb-pv-bars i {
  flex: 1 1;
  border-radius: 2px 2px 0 0;
  background: var(--rf-brand);
}
.sb-pv-bars i.is-accent {
  background: var(--rf-accent);
}
.sb-pv-modal {
  align-self: flex-end;
  width: 78%;
  padding: 8px 10px;
  border-radius: 9px;
  background: #fff;
  border: 1px solid #e7e3da;
  box-shadow: 0 6px 18px rgba(40, 34, 22, 0.14);
}
.sb-pv-modal-title {
  font-size: 10.5px;
  font-weight: 600;
  color: #191714;
  margin-bottom: 7px;
}
.sb-pv-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
}
.sb-pv-btn {
  padding: 4px 9px;
  border-radius: 6px;
  font-size: 9.5px;
  font-weight: 600;
  background: var(--rf-brand);
  color: #fff;
}
.sb-pv-btn.is-ghost {
  background: #fff;
  color: #4a453c;
  border: 1px solid #e7e3da;
}

/* printed slip */
.sb-pv-print {
  border: 1px solid #e2dcd0;
  border-radius: 4px;
  background: #fff;
  padding: 12px 14px 14px;
  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.08);
}
.sb-pv-print-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}
.sb-pv-print-head .sb-print-logo {
  height: calc(var(--rf-logo-print-h, 40px) * 0.7);
  max-width: 150px;
  object-fit: contain;
}
.sb-pv-print-meta {
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: 1px;
}
.sb-pv-print-kind {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--rf-brand);
}
.sb-pv-print-meta b {
  font: 400 16px/1 "Instrument Serif", Georgia, serif;
  color: #191714;
}
.sb-pv-print-rule {
  height: 2px;
  margin: 9px 0;
  background: var(--rf-brand);
}
.sb-pv-print-lines {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.sb-pv-print-lines span {
  height: 6px;
  border-radius: 3px;
  background: #efebe3;
}
.sb-pv-print-lines span.is-short {
  width: 55%;
  background: var(--rf-brand-tint);
}

@media (max-width: 1180px) {
  .sb-layout {
    grid-template-columns: minmax(0, 1fr);
  }
  .sb-side {
    position: static;
  }
}
@media (max-width: 560px) {
  .sb-logo-row,
  .sb-sliders {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/settings-branding.css"],"names":[],"mappings":"AAAA;;kEAEkE;;AAElE;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,4DAA4D;EAC5D,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gEAAgE;EAChE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAO;AACT;AACA;EACE,WAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,2DAA2D;EAC3D,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB;;;yDAGuD;EACvD,0BAA0B;EAC1B,iDAAiD;AACnD;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,4DAA4D;AAC9D;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;AACA;EACE,mDAAmD;EACnD,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,qDAAqD;EACrD,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;EAC3B,sCAAsC;AACxC;AACA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;AACA;EACE,SAAO;EACP,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;EACpB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,6CAA6C;AAC/C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,4CAA4C;AAC9C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;EACE,mDAAmD;EACnD,cAAc;AAChB;AACA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* Settings -> Branding. Scoped under .sb-*; shares .st-card / .st-input /\n   .st-btn-sm with settings-redesign.css. Everything inside .sb-preview\n   paints from the draft's --rf-* tokens set inline on that box. */\n\n.sb-layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(300px, 380px);\n  gap: 16px;\n  align-items: start;\n}\n.sb-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  min-width: 0;\n}\n.sb-side {\n  position: sticky;\n  top: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.sb-preview-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: #bdb6a7;\n}\n\n/* ---------------- presets ---------------- */\n.sb-presets {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 8px;\n}\n.sb-preset {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 8px 9px;\n  border: 1px solid #e2dcd0;\n  border-radius: 10px;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  font: 500 12.5px \"Instrument Sans\", Helvetica, Arial, sans-serif;\n  color: #4a453c;\n}\n.sb-preset:hover:not(:disabled) {\n  border-color: #c4bdad;\n}\n.sb-preset.is-on {\n  border-color: var(--rf-brand);\n  box-shadow: 0 0 0 1px var(--rf-brand);\n  color: #191714;\n  font-weight: 600;\n}\n.sb-preset:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n.sb-preset-swatch {\n  display: flex;\n  height: 30px;\n  border-radius: 6px;\n  overflow: hidden;\n}\n.sb-preset-swatch i {\n  flex: 1;\n}\n.sb-preset-swatch i:first-child {\n  flex: 1.4;\n}\n.sb-preset-name {\n  padding: 0 2px;\n}\n.sb-preset-check {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 18px;\n  height: 18px;\n  padding: 2px;\n  border-radius: 50%;\n  background: #fff;\n  color: var(--rf-brand);\n}\n\n/* ---------------- custom seeds ---------------- */\n.sb-seeds {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #f0ece3;\n  border-radius: 11px;\n  overflow: hidden;\n}\n.sb-seed {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n}\n.sb-seed + .sb-seed {\n  border-top: 1px solid #f0ece3;\n}\n.sb-seed-chip {\n  position: relative;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  flex-shrink: 0;\n  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n  overflow: hidden;\n}\n.sb-seed-chip input {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n}\n.sb-seed-chip input:disabled {\n  cursor: not-allowed;\n}\n.sb-seed-main {\n  flex-grow: 1;\n  min-width: 0;\n}\n.sb-seed-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #191714;\n}\n.sb-seed-help {\n  font-size: 11.5px;\n  color: #8b8477;\n}\n.st-input.sb-seed-hex {\n  flex-grow: 0;\n  width: 96px;\n  height: 30px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 12px;\n  text-transform: lowercase;\n}\n.sb-warn {\n  margin: 11px 0 0;\n  padding: 9px 12px 9px 28px;\n  border-radius: 9px;\n  background: #f9f1de;\n  border: 1px solid #ecdcb4;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #6b5629;\n}\n\n/* ---------------- logo ---------------- */\n.sb-logo-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n.sb-logo-tile {\n  height: 86px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px 16px;\n  border: 1px solid #e2dcd0;\n}\n.sb-logo-tile.is-cream {\n  background: #fff;\n}\n.sb-logo-tile.is-paper {\n  background: #fff;\n  background-image: linear-gradient(45deg, #f6f4ef 25%, transparent 25%),\n    linear-gradient(-45deg, #f6f4ef 25%, transparent 25%),\n    linear-gradient(45deg, transparent 75%, #f6f4ef 75%),\n    linear-gradient(-45deg, transparent 75%, #f6f4ef 75%);\n  background-size: 14px 14px;\n  background-position: 0 0, 0 7px, 7px -7px, -7px 0;\n}\n.sb-logo-tile .sb-logo-img,\n.sb-logo-tile .sb-print-logo {\n  max-height: 100%;\n  max-width: 100%;\n  object-fit: contain;\n}\n.sb-logo-tile.is-cream .sb-logo-img {\n  height: var(--rf-logo-h, 36px);\n}\n.sb-logo-tile.is-paper .sb-logo-img {\n  height: var(--rf-logo-print-h, 40px);\n}\n.sb-monogram {\n  height: 34px;\n  min-width: 34px;\n  padding: 0 7px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  background: #e7e3da;\n  color: #191714;\n  font-size: 14px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n}\n.sb-logo-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 11px;\n  flex-wrap: wrap;\n}\n.sb-error {\n  margin: 8px 0 0;\n  font-size: 12px;\n  color: #a8483e;\n}\n.sb-sliders {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-top: 14px;\n}\n.sb-range {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.sb-range-label {\n  display: flex;\n  justify-content: space-between;\n  font-size: 12px;\n  color: #6f6a60;\n}\n.sb-range-label b {\n  font-weight: 600;\n  color: #191714;\n}\n.sb-range input {\n  width: 100%;\n  accent-color: var(--rf-brand);\n}\n\n/* ---------------- save bar ---------------- */\n.sb-savebar {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n  padding: 11px 13px;\n  border-radius: 12px;\n  border: 1px solid #e2dcd0;\n  background: #fff;\n}\n.sb-savebar.is-dirty {\n  border-color: #ecdcb4;\n  background: #fdf8ec;\n}\n.sb-savebar-note {\n  font-size: 12px;\n  line-height: 1.45;\n  color: #6f6a60;\n}\n.sb-savebar.is-dirty .sb-savebar-note {\n  color: #6b5629;\n  font-weight: 600;\n}\n.sb-savebar-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.sb-savebar .rf-btn-primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ---------------- preview ---------------- */\n.sb-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.sb-pv-app {\n  border: 1px solid #e2dcd0;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f4f1ea;\n  font-family: \"Instrument Sans\", Helvetica, Arial, sans-serif;\n}\n.sb-pv-top {\n  position: relative;\n  z-index: 1;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 12px;\n  background: var(--rf-header);\n}\n.sb-pv-burger {\n  display: inline-flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.sb-pv-burger i {\n  width: 14px;\n  height: 2px;\n  border-radius: 1px;\n  background: #fff;\n}\n.sb-pv-logo {\n  position: relative;\n  z-index: 1;\n  align-self: flex-start;\n  height: calc(100% + 8px);\n  margin-bottom: -8px;\n  display: inline-flex;\n  align-items: center;\n  padding: 0 14px;\n  background: #fff;\n  box-shadow: 0 4px 10px rgba(25, 23, 20, 0.2);\n}\n.sb-pv-logo .sb-logo-img {\n  height: calc(var(--rf-logo-h, 36px) * 0.62);\n  max-width: 110px;\n  object-fit: contain;\n}\n.sb-pv-logo .sb-monogram {\n  height: 24px;\n  min-width: 24px;\n  font-size: 11px;\n}\n.sb-pv-name {\n  font: 400 17px/1 \"Instrument Serif\", Georgia, serif;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n.sb-pv-search {\n  width: 60px;\n  height: 20px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  flex-shrink: 0;\n}\n.sb-pv-row {\n  display: flex;\n  min-height: 190px;\n}\n.sb-pv-side {\n  width: 116px;\n  flex-shrink: 0;\n  padding: 10px 7px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background: #fbf9f5;\n  border-right: 1px solid #e2dcd0;\n}\n.sb-pv-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 7px;\n  border-radius: 6px;\n  font-size: 10.5px;\n  color: #6f6a60;\n  white-space: nowrap;\n}\n.sb-pv-nav i {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: #d8cfb8;\n  flex-shrink: 0;\n}\n.sb-pv-nav b {\n  margin-left: auto;\n  font-size: 9.5px;\n  font-weight: 600;\n  color: var(--rf-brand);\n}\n.sb-pv-nav.is-active {\n  background: var(--rf-brand-tint);\n  color: #191714;\n  font-weight: 600;\n}\n.sb-pv-nav.is-active i {\n  background: var(--rf-brand);\n}\n.sb-pv-main {\n  flex-grow: 1;\n  min-width: 0;\n  padding: 10px 12px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  position: relative;\n}\n.sb-pv-title {\n  font: 400 17px/1.1 \"Instrument Serif\", Georgia, serif;\n  color: #191714;\n}\n.sb-pv-chips {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.sb-pv-chip {\n  padding: 2px 7px;\n  border-radius: 999px;\n  font-size: 9.5px;\n  font-weight: 600;\n  background: var(--rf-brand-tint);\n  color: var(--rf-brand-deep);\n  border: 1px solid var(--rf-brand-edge);\n}\n.sb-pv-chip.is-accent {\n  background: var(--rf-accent-tint);\n  color: var(--rf-accent);\n  border-color: transparent;\n}\n.sb-pv-link {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--rf-brand);\n}\n.sb-pv-bars {\n  height: 54px;\n  display: flex;\n  align-items: flex-end;\n  gap: 7px;\n  padding: 6px 8px 0;\n  border-radius: 8px;\n  background: #fff;\n  border: 1px solid #e7e3da;\n}\n.sb-pv-bars span {\n  flex: 1;\n  height: 100%;\n  display: flex;\n  align-items: flex-end;\n  gap: 2px;\n}\n.sb-pv-bars i {\n  flex: 1;\n  border-radius: 2px 2px 0 0;\n  background: var(--rf-brand);\n}\n.sb-pv-bars i.is-accent {\n  background: var(--rf-accent);\n}\n.sb-pv-modal {\n  align-self: flex-end;\n  width: 78%;\n  padding: 8px 10px;\n  border-radius: 9px;\n  background: #fff;\n  border: 1px solid #e7e3da;\n  box-shadow: 0 6px 18px rgba(40, 34, 22, 0.14);\n}\n.sb-pv-modal-title {\n  font-size: 10.5px;\n  font-weight: 600;\n  color: #191714;\n  margin-bottom: 7px;\n}\n.sb-pv-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 5px;\n}\n.sb-pv-btn {\n  padding: 4px 9px;\n  border-radius: 6px;\n  font-size: 9.5px;\n  font-weight: 600;\n  background: var(--rf-brand);\n  color: #fff;\n}\n.sb-pv-btn.is-ghost {\n  background: #fff;\n  color: #4a453c;\n  border: 1px solid #e7e3da;\n}\n\n/* printed slip */\n.sb-pv-print {\n  border: 1px solid #e2dcd0;\n  border-radius: 4px;\n  background: #fff;\n  padding: 12px 14px 14px;\n  box-shadow: 0 1px 3px rgba(40, 34, 22, 0.08);\n}\n.sb-pv-print-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n}\n.sb-pv-print-head .sb-print-logo {\n  height: calc(var(--rf-logo-print-h, 40px) * 0.7);\n  max-width: 150px;\n  object-fit: contain;\n}\n.sb-pv-print-meta {\n  text-align: right;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n.sb-pv-print-kind {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--rf-brand);\n}\n.sb-pv-print-meta b {\n  font: 400 16px/1 \"Instrument Serif\", Georgia, serif;\n  color: #191714;\n}\n.sb-pv-print-rule {\n  height: 2px;\n  margin: 9px 0;\n  background: var(--rf-brand);\n}\n.sb-pv-print-lines {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n.sb-pv-print-lines span {\n  height: 6px;\n  border-radius: 3px;\n  background: #efebe3;\n}\n.sb-pv-print-lines span.is-short {\n  width: 55%;\n  background: var(--rf-brand-tint);\n}\n\n@media (max-width: 1180px) {\n  .sb-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n  .sb-side {\n    position: static;\n  }\n}\n@media (max-width: 560px) {\n  .sb-logo-row,\n  .sb-sliders {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
